/** The LAN fallback must execute synchronously within the initiating user gesture. */
export async function copyText(value: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
  } else {
    // HTTP LAN play has no Clipboard API; copy within the button's user gesture.
    const focused = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    const text = document.createElement('textarea');
    text.value = value;
    text.readOnly = true;
    text.tabIndex = -1;
    text.setAttribute('aria-hidden', 'true');
    text.style.position = 'fixed';
    text.style.top = '0';
    text.style.left = '0';
    text.style.opacity = '0';
    try {
      document.body.appendChild(text);
      text.select();
      if (!document.execCommand('copy')) throw new Error('Copy failed');
    } finally {
      text.remove();
      focused?.focus({ preventScroll: true });
    }
  }
}
